<template>
  <v-layout 
    
    mt-4
    justify-center 
    row>
    <!-- <v-card 
      style="width: 100%"
        
      class="ma-3">
      <v-layout>
        <v-flex 
          ml-3
          xs2
          class="text-xs-center">
          <v-img 
            :src="user.profileImg"
            aspect-ratio="1"
            style="width: 100%; height: auto; max-height: 80px; max-width: 80px; margin-top: 1em; border-radius: 50%;">
          </v-img>
        </v-flex>

        <v-flex class="text-xs-left">
          <v-card-title>
            <div>
              <div class="headline">
                Next Event
              </div>
              <div>Location</div>
              <div>8.00 P.M.</div>
            </div>
          </v-card-title>
        </v-flex>
      </v-layout>


      <v-divider light></v-divider>
      <v-card-actions class="pa-3">
        <v-btn 
          flat
          small 
          value="left"
          color="orange">
          Share
        </v-btn>
        <v-btn 
          flat 
          small 
          value="left"
          color="orange">
          Explore
        </v-btn>
        <v-spacer></v-spacer>
        Some Text
      </v-card-actions>
    </v-card> -->
  </v-layout>
</template>


<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState({
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      categories: state => state.categories
    }),
    ...mapGetters({
      user: 'user',
    }),
  }
}
</script>
